import { css } from '@fable/theme'
import { useStatsTheme } from '../../../theme/ctx'

export const FlowerPot = () => {
  const theme = useStatsTheme((s) => s.theme)
  const potColor = theme.id.includes('dark') ? '#4D2E06' : '#292229'

  return (
    <svg
      className={css`
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 25px;
      `}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.48 16.41"
    >
      <path
        d="m20.77.97l-15.71.09c-1.55,0-2.84,1.2-2.86,2.65l1.35,6.85c.44,3.28,2.75,5.87,6.22,5.85l5.83-.03c3.47-.02,5.86-2.64,6.39-5.92l1.55-6.86c.02-1.45-1.23-2.63-2.79-2.62h0Z"
        fill={potColor}
      />
      <path
        d="m24.2,0H1.28C.57,0,0,.57,0,1.28v2.88c0,.71.57,1.28,1.28,1.28h22.92c.71,0,1.28-.57,1.28-1.28V1.28c0-.71-.57-1.28-1.28-1.28Z"
        fill="#9b876f"
      />
    </svg>
  )
}
